import { useIntl } from "react-intl";
import { LabelLangString } from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";

function FilterCheckboxes({
  formClassName,
  selectAllId,
  currentLocale,
  indicatorData,
  selectedIndicator,
  listOfCheckBox,
  checkboxOptions,
  getChecked,
  onCheckedChange,
  onSelectAll,
}) {
  const intl = useIntl();

  if (indicatorData.isLoading || indicatorData.error) {
    return (
      <form className={formClassName}>
        <div className="text-center" dir="ltr">
          <h5>{intl.formatMessage({ id: "loading..." })}</h5>
        </div>
      </form>
    );
  }

  if (!selectedIndicator) {
    return (
      <form className={formClassName}>
        <div className="text-center">
          <h5>{intl.formatMessage({ id: "select-indicator" })}</h5>
        </div>
      </form>
    );
  }

  if (!listOfCheckBox || Object.keys(listOfCheckBox).length === 0) {
    return (
      <form className={formClassName}>
        <DataNotFound />
      </form>
    );
  }

  return (
    <form className={formClassName}>
      <div className="group-check-box">
        <input
          type="checkbox"
          name={selectAllId}
          id={selectAllId}
          onChange={(e) => onSelectAll(e.target.checked)}
        />
        <div className="container-label">
          <label
            htmlFor={selectAllId}
            title={intl.formatMessage({ id: "select-all" })}
          >
            {intl.formatMessage({ id: "select-all" })}
          </label>
        </div>
      </div>
      {checkboxOptions?.map(({ id, name, translations }, i) => {
        const label = LabelLangString({
          id: "name",
          currentLocale,
          defaultValue: name,
          translations,
        });
        return (
          <div key={i} className="group-check-box">
            <input
              type="checkbox"
              name={`checkbox-${name}-${id}`}
              id={`checkbox-${name}-${id}`}
              checked={getChecked(id)}
              onChange={(e) => onCheckedChange(id, e.target.checked)}
            />
            <div className="container-label">
              <label
                htmlFor={`checkbox-${name}-${id}`}
                title={label}
                className={`${label.length > 28 ? "over-28" : ""}`}
              >
                {label}
              </label>
            </div>
          </div>
        );
      })}
    </form>
  );
}

export default FilterCheckboxes;
